import React from 'react';
import { TextField, useRecordContext, useResourceDefinitions } from 'react-admin';
import _ from 'lodash';
import LinkField from './LinkField';

// Case reads always refetch and never show results from previous filters
export const CASE_QUERY_OPTIONS = {
  keepPreviousData: false,
  refetchOnMount: 'always' as const,
  refetchOnWindowFocus: true,
};

type PermittedLinkFieldProps = {
  typename: string;
  source: string;
  label?: string;
  sortable?: boolean;
};

// Plain text when the value is missing or the viewer can't open the linked record
export const PermittedLinkField = ({ typename, source, label }: PermittedLinkFieldProps) => {
  const record = useRecordContext();
  const resources = useResourceDefinitions();

  if (resources[typename]?.hasShow && !_.isNil(_.get(record, source))) {
    return <LinkField typename={typename} source={source} label={label} />;
  }
  return <TextField source={source} label={label} />;
};
